import {ManagementTransformBase} from "../TranformBase";

import {
  APIMethodEnum,
  AuthorizationTypeEnum,
  CustomActionTemplateModel,
  CustomActionTemplateListModel,
  CustomActionTemplateDetailsModel,
} from "@/api/models";
import {
  CustomAction,
  CustomActionTemplateSummary,
  GetActionTemplates200,
} from "@/api/services";
import {capitalizeFirst} from "@/utils/index";

export class CustomActionTemplateTransform extends ManagementTransformBase<CustomActionTemplateModel> {
  private mapTypeToAuthEnum = (type?: string): AuthorizationTypeEnum => {
    if (!type) return AuthorizationTypeEnum.Custom;
    const typeToAuthEnumMap: Record<string, AuthorizationTypeEnum> = {
      ghl: AuthorizationTypeEnum.GoHighLevel,
      hubspot: AuthorizationTypeEnum.Hubspot,
      salesforce: AuthorizationTypeEnum.Salesforce,
    };
    return typeToAuthEnumMap[type] || AuthorizationTypeEnum.Custom;
  };

  public makeCustomActionTemplateDetailsModel(
    dto: CustomActionTemplateSummary,
  ): CustomActionTemplateDetailsModel {
    const model: CustomActionTemplateDetailsModel = {
      title: dto.name,
      type: dto.type
        ? (capitalizeFirst(dto.type) as AuthorizationTypeEnum)
        : AuthorizationTypeEnum.Custom,
      description: dto?.description || "",
      url: dto?.url || "",
      httpMethod: dto?.http_method as APIMethodEnum,
      installationCount: dto?.installation_count || 0,
      response: dto?.response,
      prompt: dto?.prompt || "",
    };

    return model;
  }

  public makeRecordModel(dto: CustomAction): CustomActionTemplateModel {
    const itemAsAny = dto as any;

    const model: CustomActionTemplateModel = {
      id: itemAsAny.slug,
      title: itemAsAny.name,
      description: itemAsAny.description || "",
      type: this.mapTypeToAuthEnum(itemAsAny.type),
      apiUrl: itemAsAny.url || "",
      apiMethod: itemAsAny.http_method as APIMethodEnum,
    };

    return model;
  }

  public makeListModel(
    dto: GetActionTemplates200,
  ): CustomActionTemplateListModel {
    const model: CustomActionTemplateListModel = {
      records: dto.items.map(item =>
        this.makeRecordModel(item as CustomAction),
      ),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }
}

export const customActionTemplateTransform =
  new CustomActionTemplateTransform();
